import { popupComponents } from 'pages/common/popup/sheet';

export default {
  ...popupComponents,
  container: {
    width: 440,
    ...popupComponents.container,
  },
};
